import { render } from "./LoginButtons.vue?vue&type=template&id=49bfbb4e&scoped=true"
import script from "./LoginButtons.vue?vue&type=script&lang=js"
export * from "./LoginButtons.vue?vue&type=script&lang=js"

import "./LoginButtons.vue?vue&type=style&index=0&id=49bfbb4e&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49bfbb4e"]])

export default __exports__